import { Avatar, Tabs, Typography } from "@mui/material"
import Tab from "@mui/material/Tab"
import { ModelInsideQuizItem } from "api"
import Image from "next/image"
import { useState } from "react"
import { useInView } from "react-intersection-observer"
import styled from "styled-components"
import { TabPanelQuiz, a11yProps } from "./TabPanelQuiz"

const StyledQuizWrapper = styled.div<{ $inView: boolean }>`
  h2 {
    color: ${(p) => p.theme.colors.lightGrey};
    ${(p) => p.theme.breakpoints.down("sm")} {
      text-align: right;
    }
  }
  text-align: center;
  margin-bottom: 64px;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 50%;
  }
  transform: ${({ $inView }) =>
    !$inView ? "translateY(20px)" : "translateX(0)"};
  opacity: ${({ $inView }) => ($inView ? "1" : "0")};

  transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);
  transition-delay: 0.3s;
`
const StyledCaption = styled(Typography).attrs({ variant: "h2" })`
  font-size: 18px;
  font-weight: 300;
  color: rgb(213, 213, 213) !important;
  color: ${(p) => p.theme.colors.borderGrey};
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
    display: block;
  }
`

const StyledImageWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 613px;
  height: 310px;
  img {
    width: 100%;
    height: 310px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: 180px;
    img {
      width: 100%;
      height: 180px;
    }
  }
`
const StyledState = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .MuiTabs-indicator {
    display: none;
  }
  .MuiTab-root {
    background: ${(p) => p.theme.colors.disable};
  }
  .Mui-selected {
    background: ${(p) => p.theme.colors.lightGrey};
  }
  .MuiTabs-root {
    position: absolute;
    z-index: 10;
    background: ${(p) => p.theme.colors.disable};
    border-radius: 3px;
    min-height: 45px;
    height: 45px;
    bottom: -20px;
    button {
      min-width: 52px;
      width: 52px;
      min-height: 45px;
      height: 45px;
      border-radius: 3px;
    }
  }
  .MuiTab-textColorInherit {
    opacity: 1;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    .tabpanel-simple {
      width: 100%;
    }
  }
`
const StyledBody = styled(Typography).attrs({ variant: "body1" })`
  color: ${(p) => p.theme.colors.lightGrey};
  max-width: 350px;
  margin: 36px auto 0;
`
const StyledHeader = styled(Typography).attrs({ variant: "h2" })`
  color: ${(p) => p.theme.colors.white};
  text-align: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
  }
`

type QuizGameType = {
  quizData: ModelInsideQuizItem
}

const QuizGame = ({ quizData }: QuizGameType) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  const [active, setActive] = useState(0)
  const handleChange = (event, newValue) => {
    setActive(newValue)
  }

  return (
    <StyledQuizWrapper ref={ref} $inView={inView}>
      <StyledCaption>{quizData?.title || ""}</StyledCaption>
      <StyledHeader>{quizData?.subTitle || ""}</StyledHeader>
      <StyledState>
        {quizData.states.map((state, index) => (
          <TabPanelQuiz
            value={active}
            index={index}
            key={`TabPanelQuiz-${index}`}
          >
            <StyledImageWrapper>
              <Image
                src={state?.imageDesktopUrl}
                alt={state?.alt || ""}
                fill
                sizes="100vw"
                style={{
                  maxWidth: "100%",
                  objectFit: "cover",
                }}
              />
              <Tabs
                value={active}
                onChange={handleChange}
                selectionFollowsFocus
                aria-label="גלריית תמונות"
              >
                {quizData.states.map((state, index) => (
                  <Tab
                    {...a11yProps(index)}
                    label={""}
                    key={`states-${index}`}
                    aria-label={state?.description}
                    icon={
                      <Avatar
                        component={() => (
                          <Image
                            alt={state?.alt || ""}
                            src={
                              index === active
                                ? state?.activeIcon
                                : state?.inactiveIcon
                            }
                            width={24}
                            height={24}
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              objectFit: "cover",
                            }}
                          />
                        )}
                        variant="square"
                      />
                    }
                  />
                ))}
              </Tabs>
            </StyledImageWrapper>
            <StyledBody>{state?.description}</StyledBody>
          </TabPanelQuiz>
        ))}
      </StyledState>
    </StyledQuizWrapper>
  )
}

export default QuizGame
